import { render, staticRenderFns } from "./_currentMonthNonDepositor.vue?vue&type=template&id=2d580ca9&scoped=true&lang=pug"
import script from "./_currentMonthNonDepositor.vue?vue&type=script&lang=js"
export * from "./_currentMonthNonDepositor.vue?vue&type=script&lang=js"
import style0 from "./_currentMonthNonDepositor.vue?vue&type=style&index=0&id=2d580ca9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d580ca9",
  null
  
)

export default component.exports